/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PenaltyTypeEnum } from './PenaltyTypeEnum';
import {
    PenaltyTypeEnumFromJSON,
    PenaltyTypeEnumFromJSONTyped,
    PenaltyTypeEnumToJSON,
    PenaltyTypeEnumToJSONTyped,
} from './PenaltyTypeEnum';

/**
 * 
 * @export
 * @interface SoughtPenalty
 */
export interface SoughtPenalty {
    /**
     * 
     * @type {number}
     * @memberof SoughtPenalty
     */
    id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SoughtPenalty
     */
    partyId?: number | null;
    /**
     * Type of penalty sought by the SEC
     * @type {PenaltyTypeEnum}
     * @memberof SoughtPenalty
     */
    penaltyType: PenaltyTypeEnum;
    /**
     * Description of the penalty sought
     * @type {string}
     * @memberof SoughtPenalty
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof SoughtPenalty
     */
    amountSought?: number | null;
    /**
     * Whether this penalty involves monetary amounts
     * @type {boolean}
     * @memberof SoughtPenalty
     */
    isMonetary?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof SoughtPenalty
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SoughtPenalty
     */
    updatedAt?: Date | null;
}



/**
 * Check if a given object implements the SoughtPenalty interface.
 */
export function instanceOfSoughtPenalty(value: object): value is SoughtPenalty {
    if (!('penaltyType' in value) || value['penaltyType'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function SoughtPenaltyFromJSON(json: any): SoughtPenalty {
    return SoughtPenaltyFromJSONTyped(json, false);
}

export function SoughtPenaltyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SoughtPenalty {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'partyId': json['party_id'] == null ? undefined : json['party_id'],
        'penaltyType': PenaltyTypeEnumFromJSON(json['penalty_type']),
        'description': json['description'],
        'amountSought': json['amount_sought'] == null ? undefined : json['amount_sought'],
        'isMonetary': json['is_monetary'] == null ? undefined : json['is_monetary'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

export function SoughtPenaltyToJSON(json: any): SoughtPenalty {
    return SoughtPenaltyToJSONTyped(json, false);
}

export function SoughtPenaltyToJSONTyped(value?: SoughtPenalty | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'party_id': value['partyId'],
        'penalty_type': PenaltyTypeEnumToJSON(value['penaltyType']),
        'description': value['description'],
        'amount_sought': value['amountSought'],
        'is_monetary': value['isMonetary'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'updated_at': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
    };
}

